declare global {
  interface Window {
    _env_: {
      API_HOST: string;
      JUSTIN_URL: string;
      CLIENT_ID: string;
      SECRET_ID: string;
      ARTICLE_PREVIEW_URL: string;
    };
  }
}

export const APP_CONFIG = {
  API_HOST: window._env_.API_HOST,
  JUSTIN_URL: window._env_.JUSTIN_URL,
  CLIENT_ID: window._env_.CLIENT_ID,
  SECRET_ID: window._env_.SECRET_ID,
  ARTICLE_PREVIEW_URL: window._env_.ARTICLE_PREVIEW_URL,
};
